var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"bullets"},_vm._l((_vm.bullets),function(bullet,bulletKey){return _c('li',{key:bulletKey,class:[{ active: bulletKey === _vm.step }]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }